<span class="claroIconContainer">
     <span class="iconBg" [ngStyle]="{'height':size,'width':size,'background-color': colorScheme, 'border-radius': '50%'}"></span> 
     <mat-icon class="claroIconNotificationIcon" [ngStyle]="{'font-size':fontSize, 'line-height':lineHeight}" [style.height]="fontSize" [style.width]="fontSize">{{iconName}}</mat-icon>
</span>